export interface Step {
	name: StakingFlowStep;
	title?: string;
	titleValue?: string;
	button?: string;
	isPrimaryButton?: boolean;
	hasGuard?: boolean;
	canGoBack?: boolean;
	secondaryBackground?: boolean;
}

export enum StakingFlowStep {
	WELCOME = "welcome", // Introduction of a new feature, eg. Staking
	ASSET_SELECT = "asset",
	LOCKED_STAKING_DISCLAIMER = "locked_staking_disclaimer",
	LOCKED_STAKING_UNSTAKE_DISCLAIMER = "locked_staking_unstake_disclaimer",
	AMOUNT_SELECT = "amount",
	SUMMARY = "summary",
	LOCKED_STAKING_FINAL_REMINDER = "locked_staking_final_reminder",
	SUCCESS = "success",
	PENDING = "pending",
	SOLD_OUT = "sold_out"
}
